import Language from '../Language'

export default new Language(
  'Hungarian',
  ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
  ['Jan', 'Febr', 'Márc', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Szept', 'Okt', 'Nov', 'Dec'],
  ['Vas', 'Hét', 'Ke', 'Sze', 'Csü', 'Pén', 'Szo']
)
// eslint-disable-next-line
;
